<mat-toolbar class="main-toolbar">
  <mat-toolbar-row>
    <span class="logo-wrapper">
      <img class="logo" src="../../../../../assets/AZ_logo.png" alt="logo" />
    </span>
    <span class="fill-remaining-space"></span>
  </mat-toolbar-row>
</mat-toolbar>
